
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaigns/[id]",
      function () {
        return require("private-next-pages/campaigns/[id]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaigns/[id]"])
      });
    }
  